module.exports = __webpack_public_path__ + "img/banner.466318ab.png";